import script from "./ActivityCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityCatalog.vue?vue&type=script&setup=true&lang=js"

import "./ActivityCatalog.vue?vue&type=style&index=0&id=545c1845&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545c1845"]])

export default __exports__